
<template>
    
        <mars-view v-if="answerInfo" class="answer-item-container" @click.native="goDetail"><mars-view class="answer-title-box"><mars-rich-text :nodes="answerInfo.title" class="answer-title"></mars-rich-text><mars-view class="selected"><mars-view class="desc">精选</mars-view></mars-view></mars-view><mars-view class="lawyer-card-box"><lawyer-card :lawyer-info="lawyerInfo"></lawyer-card></mars-view><mars-view class="answer-content lineclamp2">
        {{ answerInfo.content }}
        <mars-view class="content-more">
            ...全文
        </mars-view></mars-view><mars-view v-if="pubTime" class="answer-time-box">
        回答于<mars-text class="time">{{ pubTime }}</mars-text></mars-view></mars-view>
    
</template>

<script>
import log from '../../../static/utils/ubcLog';
import { act } from '../../../static/utils/navigate';
import LawyerCard from "../../qaregulations/components/answer-lawyer-card.vue";
import { formatTimeToDate } from '../../qalandpage/utils/util.js';
export default {
  props: {
    // 问答信息
    answerInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    'lawyer-card': LawyerCard
  },
  computed: {
    // 律师信息
    lawyerInfo() {
      return this.answerInfo && this.answerInfo.user || {};
    },
    // 发布时间
    pubTime() {
      let {
        createTime
      } = this.answerInfo;
      if (!createTime) {
        return '';
      }
      return formatTimeToDate(createTime);
    },
    // 擅长领域
    domain() {
      return this.lawyerInfo.lawDomain && this.lawyerInfo.lawDomain.join('、') || '';
    }
  },
  methods: {
    // 跳转订单详情页
    goDetail() {
      let {
        qid
      } = this.answerInfo || {};
      if (!qid) {
        return;
      }
      act({
        target: `/question/${qid}?fr=law-search`,
        type: 'url'
      });
    }
  }
};
</script>

<style scoped>
.answer-item-container {
  background-color: #fff;
  padding: 5.07vw 0 4.35vw;
  border-bottom: 0.16vw solid #edeef0;
}
.answer-item-container .lineclamp2 {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.answer-item-container .lineclamp1 {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.answer-item-container .f-red {
  color: #eb3333;
}
.answer-item-container .answer-title-box {
  display: flex;
  align-items: center;
  font-family: PingFangSC-Medium;
  font-weight: 700;
}
.answer-item-container .answer-title-box .answer-title {
  flex-shrink: 1;
  font-size: 4.35vw;
  color: #1e1f24;
  line-height: 4.35vw;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.answer-item-container .answer-title-box .selected {
  height: 3.86vw;
  margin-left: 1.93vw;
  flex-shrink: 0;
  border: 0.24vw solid rgba(51, 102, 255, 0.4);
  border-radius: 0.97vw;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.answer-item-container .answer-title-box .selected .desc {
  font-family: PingFangSC-Medium;
  font-weight: 700;
  margin-top: 0.24vw;
  padding: 0 0.97vw;
  font-size: 2.66vw;
  color: #36f;
  line-height: 2.66vw;
}
.answer-item-container .lawyer-card-box {
  margin-top: 3.38vw;
}
.answer-item-container .answer-content {
  position: relative;
  margin-top: 0.85vw;
  font-family: PingFangSC-Regular;
  font-size: 3.38vw;
  color: #1e1f24;
  line-height: 5.56vw;
}
.answer-item-container .answer-content .content-more {
  position: absolute;
  bottom: 0;
  right: 0;
  font-family: PingFangSC-Regular;
  font-size: 3.38vw;
  color: #50525c;
  line-height: 5.56vw;
  background: #fff;
}
.answer-item-container .answer-content .content-more::before {
  content: "";
  width: 0.6rem;
  height: 100%;
  position: absolute;
  left: -0.6rem;
  top: 0;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff);
}
.answer-item-container .answer-time-box {
  margin-top: 2.54vw;
  font-family: PingFangSC-Regular;
  font-size: 3.38vw;
  color: #b7b9c1;
  line-height: 3.38vw;
}
.answer-item-container .answer-time-box .time {
  padding-left: 1.13vw;
}

</style>
